/* import __COLOCATED_TEMPLATE__ from './primary.hbs'; */
import Component from '@ember/component';

// eslint-disable-next-line ember/no-classic-classes
export default Component.extend({
  tagName: 'p',
  classNames: ['option__label--primary'],
  attributeBindings: ['data-test-option-label-text'],
  'data-test-option-label-text': 'primary'
});